// extracted by mini-css-extract-plugin
var _1 = "ra-legals-dialog";
var _2 = "ra-legals-dialog-loading";
export { _1 as "legalsDialogCls", _2 as "legalsDialogLoadingCls" }
